export const openAnotherMailbox = "VCa";
export default {openAnotherMailbox};